import { getApiBaseUrl } from "../config/apiBase";

export const getApiOrigin = () => {
  const apiBase = getApiBaseUrl();
  return apiBase.replace(/\/api\/?$/, "");
};

/** Public files are served at /uploads/... on the API host (dev and production). */
const getPublicUploadsBase = () => `${getApiOrigin()}/uploads`;

export const resolveMediaUrl = (value) => {
  if (value && typeof value === "object") {
    const objectCandidate = value.mediaUrl || value.url || value.value || "";
    return resolveMediaUrl(objectCandidate);
  }

  const raw = String(value || "").trim().replace(/\\/g, "/");
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;

  const origin = getApiOrigin();
  const uploadsBase = getPublicUploadsBase();
  const stripLeadingSlash = (v) => String(v || "").replace(/^\/+/, "");

  // Backend may return "/api/uploads/..." or "/uploads/..." — map to the public uploads URL.
  if (/^\/?api\/uploads\//i.test(raw)) {
    const normalized = raw.replace(/^\/?api\/uploads\//i, "");
    return `${uploadsBase}/${stripLeadingSlash(normalized)}`;
  }

  if (/^api\/uploads\//i.test(raw)) {
    const normalized = raw.replace(/^api\/uploads\//i, "");
    return `${uploadsBase}/${stripLeadingSlash(normalized)}`;
  }

  if (/^\/?uploads\//i.test(raw)) {
    const normalized = raw.replace(/^\/?uploads\//i, "");
    return `${uploadsBase}/${stripLeadingSlash(normalized)}`;
  }

  // If API sends "/static/media/xxx.ext", remap to public uploads (not the frontend bundle).
  if (/^\/?static\/media\//i.test(raw)) {
    const fileName = raw.split("/").pop();
    if (!fileName) return "";
    return `${uploadsBase}/${fileName}`;
  }

  if (raw.startsWith("/")) return `${getApiOrigin()}${raw}`;

  if (/^(uploads\/|\.{1,2}\/|[a-zA-Z]:\\|\\)/i.test(raw)) {
    const normalized = raw.replace(/^\.?\//, "");
    if (/^uploads\//i.test(normalized)) {
      return `${uploadsBase}/${stripLeadingSlash(normalized.replace(/^uploads\//i, ""))}`;
    }
    return `${origin}/api/${stripLeadingSlash(normalized)}`;
  }

  return "";
};
